import { useAuthStore } from "@/store/auth/auth.store";
import DashboardView  from "../shared/components/DashboardView/DashboardView";
import { Container, Box, Typography, Grid, Card, CardContent, CircularProgress } from "@mui/material";
import { GLOBAL_LABELS } from "@/shared/constants/ui/app.constants";

import {
  Business as BusinessIcon,
  Inventory as InventoryIcon,
  People as PeopleIcon,
  AccountBalance as AccountBalanceIcon,
  TrendingUp as TrendingUpIcon,
} from "@mui/icons-material"

/**
 * Dashboard page component.
 *
 * Displays the DashboardView if the user has a canal_venta assigned,
 * otherwise shows a fallback message.
 */

const DashboardPage: React.FC = () => {

  const rol = useAuthStore((state) => state.user?.rol);
  const username = useAuthStore((state) => state.user?.razon_social);

  if (rol === undefined) return <CircularProgress />;
  if (rol == 'ADMINISTRADOR' || rol == 'SUPERVISOR') {
    return <DashboardView />;
  }

  const features = [
    {
      icon: <BusinessIcon sx={{ fontSize: 40, color: "primary.main" }} />,
      title: "Ventas",
      description: "Centraliza todas las ventas de la empresa en una sola plataforma",
    },
    {
      icon: <InventoryIcon sx={{ fontSize: 40, color: "primary.main" }} />,
      title: "Control de Inventario",
      description: "Gestiona tu inventario de manera eficiente y automatizada",
    },
    {
      icon: <PeopleIcon sx={{ fontSize: 40, color: "primary.main" }} />,
      title: "Recursos Humanos",
      description: "Administra tu equipo de trabajo y procesos de RRHH",
    },
    {
      icon: <AccountBalanceIcon sx={{ fontSize: 40, color: "primary.main" }} />,
      title: "Contabilidad",
      description: "Lleva el control financiero completo de tu organización",
    },
    {
      icon: <TrendingUpIcon sx={{ fontSize: 40, color: "primary.main" }} />,
      title: "Crecimiento",
      description: "Escala tu negocio con herramientas de planificación estratégica",
    },
  ]


  return (

    <Container maxWidth="lg" sx={{ py: { xs: 6, md: 12 } }}>
      <Box textAlign="center" mb={8}>
        <Typography
          variant="h1"
          component="h1"
          sx={{
            fontSize: { xs: "2.5rem", md: "4rem" },
            mb: 3,
            color: "text.primary",
            lineHeight: 1.2,
          }}
        >
          {`¡ Bienvenido al sistema ${GLOBAL_LABELS.APP_TITLE} ${username ?? ''}!`}
        </Typography>
        <Typography
          variant="h3"
          component="p"
          sx={{
            fontSize: { xs: "1.25rem", md: "1.5rem" },
            mb: 4,
            color: "text.secondary",
            maxWidth: "800px",
            mx: "auto",
            lineHeight: 1.6,
          }}
        >
          EVA está diseñado para ayudar a gestionar los procesos relacionados con nuestros servicios de internet.
        </Typography>

      </Box>

      {/* Features Grid */}
      <Grid container spacing={4}>
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              elevation={0}
              sx={{
                height: "100%",
                border: 1,
                borderColor: "divider",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  //boxShadow: theme.shadows[4],
                },
              }}
            >
              <CardContent sx={{ p: 4, textAlign: "center" }}>
                <Box mb={2}>{feature.icon}</Box>
                <Typography
                  variant="h6"
                  component="h3"
                  gutterBottom
                  sx={{ fontFamily: "var(--font-playfair)", mb: 2 }}
                >
                  {feature.title}
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                  {feature.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default DashboardPage;
